var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19.309C38 29.972 22.912 46 19 46 15.088 46 0 29.973 0 19.309 0 8.645 8.507 0 19 0s19 8.645 19 19.309Z",
    fill: "var(--native-icon-fill)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.094 24.277H30.08c.61 0 1.094-.484 1.094-1.094v-9.72S30.943 13 30.08 13c-.863 0-1.094.463-1.094.463v8.626H9.209v-8.626S8.978 13 8.115 13C7.231 13 7 13.463 7 13.463v9.72c0 .61.484 1.094 1.094 1.094Z",
    fill: "var(--native-icon-secondary-fill)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.099 20.195c.61 0 1.094-.483 1.094-1.094v-5.638S19.96 13 19.099 13c-.863 0-1.095.463-1.095.463V19.1c-.02.59.484 1.094 1.095 1.094ZM23.977 18.953s.232.21.61.21c.38 0 .61-.21.61-.21l2.736-2.945s.294-.316.294-.568v-2.104c-.252 0-.568.294-.568.294l-3.072 3.177-3.05-3.176s-.316-.295-.568-.295v2.125c0 .252.294.568.294.568l2.714 2.924ZM12.996 18.953s.252.21.61.21c.379 0 .61-.21.61-.21l2.735-2.945s.295-.316.295-.568v-2.104c-.253 0-.59.294-.59.294l-3.07 3.177-3.052-3.176s-.315-.295-.589-.295v2.125c0 .252.295.568.295.568l2.756 2.924Z",
    fill: "var(--native-icon-secondary-fill)"
  })));
};

export default SvgPin;